// 定义常量
export const types = {
    CONFIRM_CONFIRM: 'user/ui/confirm/CONFIRM',
    CONFIRM_HIDE: 'user/ui/confirm/HIDE',
    CONFIRM_SHOW: 'user/ui/confirm/SHOW'
}

let bindConfirmAction: any;
let bindHideAction: any;

// 定义action接口
export interface IConfirmAction {
    type: string;
    data?: {
        type?: number;
        text: string;
        onConfirm?(r: any): void;
        onHide?(): void;
        confirm?: string,
        cancel?: string
    }
}
// 定义状态接口
export interface IConfirmStoreState {
    text: string;
    type: number;
    visible: boolean;
    confirm?: string,
    cancel?: string
}

// 隐藏操作
export const hideAction = () => {
    return {
        type: types.CONFIRM_HIDE
    }
}
// 确认操作
export const confirmAction = () => {
    return {
        type: types.CONFIRM_CONFIRM
    }
}

const initState = {
    text: '',
    type: 0,
    visible: false,
    confirm: '确定',
    cancel: '取消'
}

export default (state: IConfirmStoreState = initState, action: IConfirmAction): IConfirmStoreState => {
    switch(action.type) {
        case types.CONFIRM_CONFIRM:
            if(bindConfirmAction) {
                bindConfirmAction();
            }
            return initState
        case types.CONFIRM_SHOW:
            // 绑定确认处理函数
            if(action.data && action.data.onConfirm) {
                bindConfirmAction = action.data.onConfirm;
            } else {
                bindConfirmAction = null;
            }
            // 绑定取消处理函数
            if(action.data && action.data.onHide) {
                bindHideAction = action.data.onHide;
            } else {
                bindHideAction = null;
            }

            console.log(action.data)
            return {
                text: action.data ? action.data.text : '',
                type: action.data ? (action.data.type || 0) : 0,
                visible: true,
                confirm: (action.data && action.data.confirm) ? action.data.confirm : '确定',
                cancel: (action.data && action.data.cancel) ? action.data.cancel : '取消'
            }
        case types.CONFIRM_HIDE:
            if(bindHideAction) {
                bindHideAction();
            }
            return initState
        default:
            return state;
    }
}
